export const trackEvent = (
    eventName,
    eventCategory,
    eventAction,
    eventLabel = '',
    eventValue = 0
) => {
    if (window.gtag) {
        window.gtag('event', eventName, {
            eventCategory,
            eventLabel,
            eventAction,
            eventValue
        });
    }
};
